export class Month {
    public monthNumber: number;
    public monthDayStart: number;
    public monthDayEnd: number;
}

export class Timeline {
    public months: Month[] = new Array<Month>();
}
